export const developers = {
    Heads: [
        {
            "Name": "Ayush Kansal",
            "Committee": "Websiite Management",
            Instagram:"https://www.instagram.com/ayush.03.16/",
            Linkedin:"https://www.linkedin.com/in/ayush-kansal-a6b788279/",
            "Photo": "/team/Ayush_Kansal.png",
            "Email": "ayushkansal777@gmail.com",
            "Contact": "9463741383",
            "Type": "Head"
          },
        {
            "Name": "Prranav Babbar",
            "Committee": "Website Management",
            Instagram: "NA",
            Linkedin: "NA",
            "Photo": "/team/PrranavBabbar_13_11zon.webp",
            "Email": "prranavbabbar2317@gmail.com",
            "Contact": "6284691173",
            "Type": "Head"
        }
    ],
    Developers: [
        {
            "Name": "Prasuk Jain",
            Instagram: "https://www.instagram.com/prasukjain_07?igsh=N3hkcTR3Z3hqNTRh",
            Linkedin: "https://www.linkedin.com/in/prasuk-jain-1053b5244/",
            "Photo": "/team/PrasukJain.jpg",
            "Email": "prasukjain0703@gmail.com",
            "Contact": "7417345233",
        },
        {
            "Name": "Ribhav Aggarwal",
            Instagram: "NA",
            Linkedin: "NA",
            "Photo": "/team/Ribhav.jpg",
            "Email": "NA",
            "Contact": "NA"

            
        },
        {
            "Name": "Lakshya Verma",
            Instagram: "NA",
            Linkedin: "NA",
            "Photo": "/team/Lakshya.jpg",
            "Email": "lakshyaverma.bt22cse@pec.edu.in",
            "Contact": "9878801587"

            
        },
        {
            "Name": "Vasu Garg",
            Instagram: "NA",
            Linkedin: "NA",
            "Photo": "/team/Vasu_garg.jpg",
            "Email": "NA",
            "Contact": "7529025865",
        },
        {
            "Name": "Hardik Handa",
            Instagram: "NA",
            Linkedin: "NA",
            "Photo": "/team/Hardik_handa.jpg",
            "Email": "NA",
            "Contact": "NA",
        },

        
    ],
    UI: [
        {
            "Name": "Priyanshu",
            "Committee": "Creative Head",
            Instagram:"NA",
            Linkedin:"NA",
            "Photo": "/team/Priyanshu_creativehead_7814610757_12_11zon.webp",
            "Email": "priyanshu.bt21ece@pec.edu.in",
            "Contact": "7814610757",
            "Type": "Head"
          },
        {
            "Name": "Sristi",
            "Committee": "Creative",
            Instagram:"NA",
            Linkedin:"NA",
            "Photo": "/team/sristi.jpg",
            "Email": "sristi282002@gmail.com",
            "Contact": "7088425716",
            "Type": "Head"
          },
          {
              "Name": "Vikas Attri",
              "Committee": "Creative",
              Instagram:"NA",
              Linkedin:"NA",
              "Photo": "/team/vikas.png",
              "Email": "vikasattri8285@gmail.com",
              "Contact": "8383075442",
              "Type": "Head"
            },
        {
            "Name": "Daksh Bilkha",
            "Committee": "Creative",
            Instagram:"NA",
            Linkedin:"NA",
            "Photo": "/team/daksh.jpg",
            "Email": "bilkhadaksh@gmail.com",
            "Contact": "9636566881",
            "Type": "Head"
          },
        {
            "Name": "Aryaman Vij",
            "Committee": "Creative",
            Instagram:"NA",
            Linkedin:"NA",
            "Photo": "/team/aryaman.png",
            "Email": "aryamanvij16@gmail.com",
            "Contact": "8384848727",
            "Type": "Head"
          },
        {
            "Name": "Akash",
            "Committee": "Creative",
            Instagram:"NA",
            Linkedin:"NA",
            "Photo": "/team/akash.jpg",
            "Email": "akashanand032002@gmail.com",
            "Contact": "8800049371",
            "Type": "Head"
          },
    ]
}
